import { CalculatedConsentStatus } from './consent';

export type FieldType = 'phone' | 'email' | 'fax' | 'mobile';

export type Field = {
  type: FieldType;
  value: string;
  comment: string;
  consentStatus?: CalculatedConsentStatus | null;
  id?: string;
};

export type ContactType = 'person' | 'department';

export type Contact = {
  type: ContactType;
  id?: number;
  businessUnitIds: number[];
  firstName: string;
  lastName: string;
  title: string;
  note: string;
  fields: Field[];
  claimResolution?: boolean;
};

export interface ContactPerson {
  type: 'contact' | 'patient';
  id: number;
  firstName: string;
  lastName: string;
  fields: Field[];
  phiChallengeData?: {
    hasLastName: boolean;
    hasDateOfBirth: boolean;
    hasSsnLastFour: boolean;
  };
}

export type BulkEstimateContact = ContactPerson & {
  estimateIds: number[];
};

export enum BulkEstimateContactType {
  EMAIL = 'email',
  SMS = 'sms',
}

export function cleanContactField(field: Field) {
  if (field && (field.type == 'phone' || field.type == 'mobile')) {
    return {
      ...field,
      value: cleanPhoneNumber(field.value),
    };
  }
  return field;
}

export function cleanPhoneNumber(value: string) {
  return value ? value.replace(/\D/g, '') : value;
}

export function formatPhoneNumber(value: string) {
  let result = cleanPhoneNumber(value);
  if (result == '') {
    return result;
  }
  if (result.startsWith('1')) {
    result = result.substring(1);
  }
  if (result.length > 3) {
    return result.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})(.*)/, '($1) $2-$3');
  }
  return result.replace(/^(\d{0,3})/, '($1)');
}

export function emptyField(type: FieldType): Field {
  return {
    type: type,
    value: '',
    comment: '',
  };
}
